import React, { useState } from "react";
import RefundPolicyModal from "../components/refundPolicyModal";
import API from '../services/API';
import "../styles/menu.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    jewelryType: " ",
    metalPreference: " ",
    budget: " ",
    timeframe: " ",
    description: "",
  });
  const [status, setStatus] = useState("");
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    try {
      const response = await API.contactEmail(formData);

      if (response.success) {
        setStatus("Thank you! Your inquiry has been sent successfully.");
        // Clear the form
        setFormData({
          name: "",
          email: "",
          jewelryType: " ",
          metalPreference: " ",
          budget: " ",
          timeframe: " s",
          description: "",
        });
      } else {
        setStatus("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error('Contact form error:', error);
      setStatus("An error occurred. Please try again later.");
    }
  };

  return (
    <div className="flex flex-col justify-center items-center min-h-screen p-4 overflow-x-hidden">
      
      <div className="text-center max-w-4xl mx-auto p-4 opacity-80 relative z-20">
        <p className="custom-font-text text-xl">
          We specialize in custom pieces, giving you a personal connection to history.
        </p>
        <div className="h-0.5 mt-4 mb-4 w-full bg-secondary"></div>
        <p className="text-lg">
          Whether you're drawn to a Roman emperor's portrait, Greek mythology, 
          another facet of ancient culture, or have a meaningful coin of your own already, 
          our goal is to create a piece that speaks to you and your story.
        </p>
      </div>

      <div className="relative w-screen h-[90vh]">
        <img 
          src={process.env.PUBLIC_URL + "/leighContactImage.jpg"}
          alt="Contact Us Banner" 
          className="w-screen h-[100%] object-cover"
        />
        
        <div className="absolute bottom-8 right-8 bg-white/80 p-8 rounded-lg shadow-lg max-w-md">
          <h2 className="text-3xl font-bold mb-2 custom-font-text">Questions? Ideas?</h2>
          <h3 className="text-2xl mb-4 custom-font-text">Let's Chat!</h3>
          <p className="text-lg mb-6">We'd love to hear from you!</p>
          
          <button 
            onClick={() => setShowForm(true)}
            className="border-2 border-accent bg-transparent text-accent px-8 py-3 rounded-full hover:bg-accent/40 transition-all duration-300"
          >
            GET IN TOUCH
          </button>
        </div>
      </div>

      {showForm && (
        <div className="w-full max-w-4xl p-2 bg-white rounded-lg shadow-md my-8">
          <h2 className="text-2xl font-bold mb-6 text-center custom-font-text">Let's Design Together</h2>
          
          {status && (
            <div className="mb-4 text-center text-accent">{status}</div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-700 mb-2">Name*</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-gray-700 mb-2">Email*</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              </div>

            <div>
              <label className="block text-gray-700 mb-2">Tell us about your vision*</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Please describe any specific details about your desired piece, including design preferences, size requirements, or any questions you may have."
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 h-32"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-accent text-white py-2 px-4 rounded-lg hover:bg-accent-content transition-colors"
            >
              Submit
            </button>
          </form>
        </div>
      )}

      <RefundPolicyModal 
        isOpen={isRefundModalOpen} 
        onClose={() => setIsRefundModalOpen(false)} 
      />
    </div>
  );
};

export default Contact;